import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 31
class PrintReportPOReceivedProduct extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        let type = this.props.type==''?'received':this.props.type
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.shopId!=undefined&&this.props.type!=undefined) {
            ReportStore.loadReportPurchaseorderRecordProduct(this.props.year,this.props.month,this.props.day,this.props.shopId,type,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.shopId!=undefined&&this.props.type!=undefined) {
            ReportStore.loadReportPurchaseorderRecordProductRange(this.props.startDate,this.props.endDate,this.props.shopId,type,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary() {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total = total + (item.amount==''||item.amount==null||item.amount==undefined||isNaN(item.amount)?0:parseFloat(item.amount))
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={11}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
              <td className='text-center'>{(indexs*30)+index+1}</td>
              <td className='text-center'>{item.record_date}</td>
              <td className='text-center'>{item.purchase_order_no}</td>
              <td className='text-left'>{item.detail}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-right'>{this.getNumberFormat(item.price_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(item.discount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.vat)}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
              <td className='text-center'>{item.recieved_by}</td>
              <td className='text-left'>{item.remark}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        let {type} = this.props
        return(
            <table className='table table-print-report-po-received-product'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'20px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'90px'}}>วันที่</td>
                        <td className='text-center' style={{width:'100px'}}>เลขใบสั่งซื้อ</td>
                        <td className='text-center' style={{width:'170px'}}>รายการ</td>
                        <td className='text-center' style={{width:'50px'}}>จำนวน</td>
                        <td className='text-center' style={{width:'80px'}}>ราคา</td>
                        <td className='text-center' style={{width:'80px'}}>ส่วนลด</td>
                        <td className='text-center' style={{width:'80px'}}>ภาษี</td>
                        <td className='text-center' style={{width:'80px'}}>รวม</td>
                        <td className='text-center' style={{width:'90px'}}>{type=='received'?'ผู้รับ':type=='exportwork'?'ผู้เบิก':type=='return'?'ผู้คืน':'ผู้รับ'}</td>
                        <td className='text-center' style={{width:'120px'}}>หมายเหตุ</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {index==length-1?
                    <tr>
                        <td colSpan={8} className='text-right'>รวมทั้งหมด</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary())}</td>
                        <td colSpan={2} className='text-right'></td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.type=='received'?'ตารางรายงานรับอะไหล่จากใบสั่งซื้อ':this.props.type=='exportwork'?'ตารางรายงานเบิกอะไหล่จากใบสั่งซื้อ':this.props.type=='return'?'ตารางรายงานคืนอะไหล่จากใบสั่งซื้อ':this.props.type=='purchaseorder_item_product'?'ตารางรายงานสั่งซื้อวัสดุ - อะไหล่ (แจงรายละเอียด)':'ตารางรายงานรับอะไหล่จากใบสั่งซื้อ'}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.type=='received'?'ตารางรายงานรับอะไหล่จากใบสั่งซื้อ':this.props.type=='exportwork'?'ตารางรายงานเบิกอะไหล่จากใบสั่งซื้อ':this.props.type=='return'?'ตารางรายงานคืนอะไหล่จากใบสั่งซื้อ':this.props.type=='purchaseorder_item_product'?'ตารางรายงานสั่งซื้อวัสดุ - อะไหล่ (แจงรายละเอียด)':'ตารางรายงานรับอะไหล่จากใบสั่งซื้อ'}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.type=='received'?'ตารางรายงานรับอะไหล่จากใบสั่งซื้อ':this.props.type=='exportwork'?'ตารางรายงานเบิกอะไหล่จากใบสั่งซื้อ':this.props.type=='return'?'ตารางรายงานคืนอะไหล่จากใบสั่งซื้อ':this.props.type=='purchaseorder_item_product'?'ตารางรายงานสั่งซื้อวัสดุ - อะไหล่ (แจงรายละเอียด)':'ตารางรายงานรับอะไหล่จากใบสั่งซื้อ'}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportPOReceivedProduct.defaultProps = {
    title: '',
    mode: '',
    workNo: '',
    type: 'received'
  }
  export default PrintReportPOReceivedProduct;


// WEBPACK FOOTER //
// ./src/view/print/po/PrintReportPOReceivedProduct.js